import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@src/components/Image';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import './styles.scss';

export function EmptyState({ title }) {
  return (
    <div className="feed-empty-state">
      <Image className="feed-empty-state__image" src={`${STATIC_MEDIA_DOMAIN}/images/no-posts-yet.png`} />

      <div className="feed-empty-state__title">{title}</div>
    </div>
  );
}

EmptyState.propTypes = {
  title: PropTypes.string,
};

EmptyState.defaultProps = {
  recruiter: { rights: {} },
  title: 'No reviews given yet',
};
